const options = {
  5: "bg-orange-400/5",
  10: "bg-orange-400/10",
  25: "bg-orange-400/25",
  50: "bg-orange-400/50",
  75: "bg-orange-400/75",
  90: "bg-orange-400/90",
  100: "bg-orange-400",
};

const from = {
  5: "from-orange-400/5",
  10: "from-orange-400/10",
  25: "from-orange-400/25",
  50: "from-orange-400/50",
  75: "from-orange-400/75",
  90: "from-orange-400/90",
  100: "from-orange-400",
};

export default function getBackgroundOrange400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
